import React from 'react';
import { connect } from 'react-redux';
import { I18n, Translate } from 'react-redux-i18n';

import BannersAction from '../app/store/actions/banners';
import DropZoneComponent from '../components/dropzone';
import InputComponent from '../components/elements/input';
import TextArea from '../components/elements/textArea';
import SelectComponent from '../components/select/Select';
import HeaderComponent from '../components/table/header/headerComponent';
import FIELDS from '../data/fields';
import ROUTES from '../data/routes';
import randomPassword from '../helpers/generator';
import VALIDATOR from '../helpers/validator/formValidator';
import { history } from '../routers/AppRouter';

class BannersForm extends React.Component {
  constructor(props) {
    super(props);

    const UrlApp = [
      { name: I18n.t('screenHome'), value: 'ACTION_OPEN_HOME' },
      { name: I18n.t('screenProduct'), value: 'ACTION_OPEN_PRODUCTS' },
      { name: I18n.t('screenCart'), value: 'ACTION_OPEN_CART' },
    ];
    this.state = {
      id: '',
      name: '',
      description: '',
      redirectUrl: '',
      imageUrl: '',
      message: '',
      success: '',
      active: true,
      typeBanner: 1,
      loadImage: false,
      file: '',
      isUpdate: false,
      displayOn: 'web',
      UrlApp,
      urlInternal: '',
      parametersUrl: '',
    };
  }

  async componentDidMount() {
    if (this.props.location.search) {
      const { search } = this.props.location;
      const splited = search.split('=');
      const id = splited[1];
      await this.props.getBanner(id);
      const {
        description, imageUrl, name, redirectUrl, active, typeBanner,
        displayOn,
      } = this.props.banner;
      let urlInternal = '';
      let parametersUrl = '';
      if (displayOn === 'app' && redirectUrl) {
        const result = JSON.parse(redirectUrl);
        // eslint-disable-next-line prefer-destructuring
        urlInternal = result.urlInternal;
        delete result.urlInternal;
        parametersUrl = (Object.keys(result).length)
          ? Object.entries(result).map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join('&')
          : '';
      }
      await this.setState({
        id,
        description,
        imageUrl,
        name,
        redirectUrl,
        active,
        isUpdate: true,
        typeBanner: parseInt(typeBanner, 10),
        urlInternal,
        parametersUrl,
        displayOn,
      });
    }
  }

  goBack = () => {
    history.push(ROUTES.BANNERS);
  }

  formatUrlParameters = (parametersUrl, urlInternal) => {
    const result = parametersUrl.split('?');
    const paramString = (result.length === 2) ? result[1].split('&') : result[0].split('&');

    const queryParams = {};
    // eslint-disable-next-line no-restricted-syntax
    for (const query of paramString) {
      const [key, value] = query.split('=');
      queryParams[key] = decodeURIComponent(value);
    }
    return JSON.stringify({ urlInternal, ...queryParams });
  }

  uploadedFile = async (file, id) => {
    if (!file) {
      this.setState({ message: I18n.t('selectImage'), success: '' });
    } else {
      try {
        await this.setState({ loadImage: true });
        const hash = randomPassword();
        const extension = file[0].name.split('.').pop();
        const opico = this.props.settings.name;
        const name = `${opico}${hash}.${extension}`;
        const img = await BannersAction.uploadBanner(file[0], name, id);
        return img.name;
      } catch (err) {
        await this.setState({ message: I18n.t('invalidImageFormat'), success: '' });
      } finally {
        await this.setState({ loadImage: false });
      }
    }
  }

  createBanner = async () => {
    const {
      name, description, redirectUrl, file, typeBanner, parametersUrl, displayOn, urlInternal,
    } = this.state;

    const imageUrl = await this.uploadedFile(file);

    let newUrlInternal = (urlInternal) ? JSON.stringify({ urlInternal }) : '';
    if (urlInternal && parametersUrl) newUrlInternal = this.formatUrlParameters(parametersUrl, urlInternal);

    if (imageUrl) {
      const valid = VALIDATOR.BannerValidator({ name, description });
      if (valid.success) {
        await this.props.createBanner({
          name,
          description,
          imageUrl,
          redirectUrl: (displayOn === 'app') ? newUrlInternal : redirectUrl,
          displayOn,
          active: true,
          typeBanner,
        });
        await this.setState({
          message: '',
          success: I18n.t('bannerCreated'),
          id: '',
          name: '',
          description: '',
          redirectUrl: '',
          imageUrl: '',
          active: true,
          typeBanner: 1,
          displayOn: 'web',
          parametersUrl: '',
          urlInternal: '',
          file: '',
        });
      } else {
        await this.setState({ message: valid.message, success: '' });
      }
    }
  }

  updateBanner = async () => {
    const {
      name, description, redirectUrl, id, active, file, typeBanner, parametersUrl, displayOn, urlInternal,
    } = this.state;
    let image;

    let newUrlInternal = (urlInternal) ? JSON.stringify({ urlInternal }) : '';
    if (urlInternal && parametersUrl) newUrlInternal = this.formatUrlParameters(parametersUrl, urlInternal);

    if (file) {
      image = await this.uploadedFile(file, id);
    }

    const valid = VALIDATOR.BannerValidator({ name, description });
    if (valid.success) {
      await this.props.updateBanner({
        name,
        description,
        imageUrl: image,
        redirectUrl: (displayOn === 'app') ? newUrlInternal : redirectUrl,
        active,
        id,
        displayOn,
        typeBanner,
      });
      await this.setState({ message: '', success: I18n.t('bannerUpdated') });
    } else {
      await this.setState({ message: valid.message, success: '' });
    }
  }

  render() {
    const {
      name,
      description,
      redirectUrl,
      imageUrl,
      id,
      message,
      success,
      loadImage,
      isUpdate,
      file,
      typeBanner,
      displayOn,
      urlInternal,
      UrlApp,
      parametersUrl,
    } = this.state;

    return (
      <div className="main-table">
        <HeaderComponent
          title={I18n.t('bannerRegister')}
        />
        <div className="justify-content-center display-flex">
          {isUpdate
          && (
          <img
            src={imageUrl || 'images/default-image.jpg'}
            className="img-logo-banners"
            alt="Logo"
          />
          )
          }
        </div>
        <div className="row margin-bottom-20 banner-form-div justify-content-center">

          <div className="dropzone-out">
            <DropZoneComponent
              uploadedFile={e => this.setState({ file: e, success: '', message: '' })}
              title={I18n.t('dragBanner')}
              loadImage={loadImage}
              fileName={file && file[0].name}
            />
          </div>
        </div>
        <div className="form-group">

          <p className="margin-bottom-2">{I18n.t('displayOn')}</p>
          <select
            onChange={e => this.setState({ displayOn: e.target.value })}
            required
            className="custom-select"
            defaultValue="web"
            value={displayOn}
          >
            <option value="web">{`${I18n.t('web')} - (2280px x 812px)`}</option>
            <option value="webMobile">{`${I18n.t('webMobile')} - (1080px  x 1080px)`}</option>
            <option value="app">{`${I18n.t('app')} - (1080px x 1080px)`}</option>
          </select>
          <p />
          <p className="margin-bottom-2"><Translate value="name" /></p>
          <InputComponent
            type="text"
            className="form-control"
            placeHolder=""
            onChange={e => this.setState({ name: e.target.value })}
            value={name}
            maxLength={FIELDS.max}
          />

          {displayOn === 'app' ? (
            <React.Fragment>
              <div className="form-group">
                <SelectComponent
                  title={I18n.t('urlToRedirectInternal')}
                  value={urlInternal}
                  body={UrlApp.map(val => (<option key={val.value} value={val.value}>{val.name}</option>))}
                  onChange={(e) => {
                    this.setState({ urlInternal: `${e.target.value}`, parametersUrl: '' });
                  }}
                />
              </div>
              {(urlInternal === 'ACTION_OPEN_PRODUCTS') && (
                <div className="form-group">
                  <p className="margin-bottom-2">
                    {I18n.t('filterProducts')}
                  </p>
                  <input
                    type="text"
                    onChange={e => this.setState({ parametersUrl: `${e.target.value}` })}
                    value={parametersUrl}
                    className="form-control"
                  />
                </div>
              )}
            </React.Fragment>
          ) : (
            <React.Fragment>
              <p className="margin-bottom-2"><Translate value="urlToRedirect" /></p>
              <InputComponent
                type="text"
                className="form-control"
                placeHolder=""
                onChange={e => this.setState({ redirectUrl: e.target.value })}
                value={redirectUrl}
                maxLength={FIELDS.max}
              />
            </React.Fragment>
          )}

          <TextArea
            title={I18n.t('description')}
            onChange={e => this.setState({ description: e.target.value })}
            value={description}
            maxLength=""
            placeHolder=""
            rows={3}
          />

          {this.props.settings.companyTag === 'chile'
            && (
              <React.Fragment>
                <div className="form-check">
                  <input
                    type="radio"
                    id="spotCheck"
                    className="form-check-input"
                    value={1}
                    checked={typeBanner === 1}
                    onChange={e => this.setState({ typeBanner: parseInt(e.target.value, 10) })}
                  />
                  <span>{I18n.t('bannersMain')}</span>
                </div>
                <div className="form-check">
                  <input
                    type="radio"
                    id="spotCheck"
                    className="form-check-input"
                    value={2}
                    checked={typeBanner === 2}
                    onChange={e => this.setState({ typeBanner: parseInt(e.target.value, 10) })}
                  />
                  <span>{I18n.t('greenPortfolio')}</span>
                </div>
                <div className="form-check">
                  <input
                    type="radio"
                    id="spotCheck"
                    className="form-check-input"
                    value={3}
                    checked={typeBanner === 3}
                    onChange={e => this.setState({ typeBanner: parseInt(e.target.value, 10) })}
                  />
                  <span>{I18n.t('projectsForIntegrators')}</span>
                </div>
                <div className="form-check" style={{ marginBottom: '1rem' }}>
                  <input
                    type="radio"
                    id="spotCheck"
                    className="form-check-input"
                    value={4}
                    checked={typeBanner === 4}
                    onChange={e => this.setState({ typeBanner: parseInt(e.target.value, 10) })}
                  />
                  <span>{I18n.t('offer')}</span>
                </div>
              </React.Fragment>
            )
          }

          <button
            type="button"
            onClick={this.goBack}
            className="btn btn-warning margin-right-15"
          >
            <Translate value="return" />
          </button>
          {id
            ? (
              <button
                type="button"
                className="btn btn-dark margin"
                onClick={this.updateBanner}
              >
                <Translate value="update" />
              </button>
            )
            : (
              <button
                type="button"
                className="btn btn-dark"
                onClick={this.createBanner}
              >
                <Translate value="register" />
              </button>
            )
          }
          {success && <p className="color-green margin-top-10">{success}</p>}
          {message && <p className="color-red margin-top-10">{message}</p>}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getBanner: id => dispatch(BannersAction.getBanner(id)),
  updateBanner: banner => dispatch(BannersAction.updateBanner(banner)),
  createBanner: banner => dispatch(BannersAction.createBanner(banner)),
});

const mapStateToProps = state => ({
  banner: state.banners && state.banners.banner,
  settings: state.settings,
});

export default connect(mapStateToProps, mapDispatchToProps)(BannersForm);
